import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import DiscoveryV2OnboardingScreen from '../screens/Onboarding/DiscoveryV2OnboardingScreen';
import LoginScreen from '../screens/Auth/LoginScreen';
import RegisterScreen from '../screens/Auth/RegisterScreen';
import ForgotPasswordScreen from '../screens/Auth/ForgotPasswordScreen';
import SplashScreen from '../screens/Auth/SplashScreen';

export type AuthStackParamList = {
  Splash: undefined;
  DiscoveryV2Onboarding: undefined;
  Login: undefined;
  Register: undefined;
  ForgotPassword: undefined;
};

const Stack = createNativeStackNavigator<AuthStackParamList>();

const AuthNavigator = () => {
  return (
    <Stack.Navigator initialRouteName="Splash">
      <Stack.Screen 
        name="Splash" 
        component={SplashScreen} 
        options={{ headerShown: false }} 
      />
      <Stack.Screen name="Register" component={RegisterScreen} options={{ headerShown: false }} />
      <Stack.Screen name="Login" component={LoginScreen} options={{ headerShown: false }} />
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} options={{ title: 'Reset Password' }} />
      <Stack.Screen name="DiscoveryV2Onboarding" component={DiscoveryV2OnboardingScreen} options={{ headerShown: false }} />
    </Stack.Navigator>
  );
};

export default AuthNavigator; 